import { Box, Checkbox, Image, useTheme, VStack } from '@chakra-ui/react';

import Text from 'components/Text';

interface PurchasingPowerBannerProps {
  discount: number;
  isPPPActive: boolean;
  setIsPPPActive: (value: boolean) => void;
  countryFlag?: string;
  countryName?: string;
}

export const PurchasingPowerBanner = ({
  discount,
  isPPPActive,
  setIsPPPActive,
  countryFlag,
  countryName,
}: PurchasingPowerBannerProps) => {
  const { borderRadius } = useTheme();

  return (
    <Box
      width="100%"
      padding={4}
      borderRadius={8}
      background="linear-gradient(90deg, rgba(159, 122, 234, 0.87) 0%, rgba(237, 137, 54, 0.87) 100%)"
    >
      <VStack spacing={4}>
        <Text fontWeight="semibold" fontSize="large" textTransform="uppercase">
          It looks like you are based in{' '}
          <span
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              paddingLeft: 4,
              paddingRight: 4,
            }}
          >
            <Image src={countryFlag} boxSize="24px" borderRadius={16} />
          </span>{' '}
          {countryName}
        </Text>
        <Text fontWeight="medium" textAlign="center">
          We embrace Purchasing Power Parity (PPP), so a {discount}% discount will <br />
          be automatically applied during checkout! 😊
        </Text>
        <Box bg="gray.900" borderRadius={borderRadius} px={3} py={2}>
          <Checkbox
            sx={{
              '.chakra-checkbox__control': {
                _checked: {
                  bg: 'purple.600',
                  borderColor: 'purple.600',
                  color: 'white',
                  _hover: {
                    bg: 'purple.500',
                    borderColor: 'purple.500',
                  },
                },
              },
            }}
            isChecked={isPPPActive}
            onChange={(e) => setIsPPPActive(e.target.checked)}
          >
            <Text>{discount}% Discount Activated*</Text>
          </Checkbox>
        </Box>
        <Text fontSize="micro" fontWeight="regular">
          {`*PPP discount can't be stacked with promo codes`}
        </Text>
      </VStack>
    </Box>
  );
};
